import React from "react";
import Grid from "@mui/material/Grid";
import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: "100vh",
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    centered: {
      height: "100vh",
    },
  })
);

interface LayoutNakedProps {
  variant?: "centered" | "normal";
  children?: React.ReactNode;
}

export default function LayoutNaked(props: LayoutNakedProps) {
  const { variant, children } = props;
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={3}
        alignItems="center"
        justifyContent="center"
        className={clsx({ [classes.centered]: variant === "centered" })}
      >
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </div>
  );
}
